import { useEffect, useRef } from 'react';
import { useShowAds } from '../hooks/useShowAds';

const AdsterraBanner = ({ adKey, width, height, testId, marginTop = 24, marginBottom = 24 }) => {
  const { showAds } = useShowAds();
  const containerRef = useRef(null);
  const initializedRef = useRef(false);

  useEffect(() => {
    if (!showAds || initializedRef.current) return;
    const node = containerRef.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !initializedRef.current) {
          initializedRef.current = true;

          // Set atOptions via inline script to avoid global collision
          const optionsScript = document.createElement('script');
          optionsScript.text = `atOptions = { 'key': '${adKey}', 'format': 'iframe', 'height': ${height}, 'width': ${width}, 'params': {} };`;
          node.appendChild(optionsScript);

          // Load the Adsterra invoke script
          const invokeScript = document.createElement('script');
          invokeScript.src = `https://www.highperformanceformat.com/${adKey}/invoke.js`;
          invokeScript.async = true;
          node.appendChild(invokeScript);

          // Sandbox the iframe once Adsterra creates it (block forced redirects)
          const iframeObserver = new MutationObserver(() => {
            const iframe = node.querySelector('iframe');
            if (iframe && !iframe.getAttribute('sandbox')) {
              iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-popups');
              iframeObserver.disconnect();
            }
          });
          iframeObserver.observe(node, { childList: true, subtree: true });

          observer.disconnect();
        }
      },
      { rootMargin: '300px' }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [showAds, adKey, width, height]);

  if (!showAds) return null;

  return (
    <div
      data-testid={testId || 'adsterra-banner'}
      style={{ width: '100%', marginTop, marginBottom }}
    >
      <span style={{ fontSize: 11, color: '#6b7280', display: 'block', marginBottom: 2 }}>Adv</span>
      <div
        ref={containerRef}
        style={{ width: '100%', display: 'flex', justifyContent: 'flex-start', minHeight: height }}
      />
    </div>
  );
};

export default AdsterraBanner;
